/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { WarehouseInfoDTOFromJSON, } from '../models/index';
/**
 *
 */
export class WarehouseInfoControllerApi extends runtime.BaseAPI {
    /**
     */
    async getWarehouseInfoRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-info`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseInfoDTOFromJSON(jsonValue));
    }
    /**
     */
    async getWarehouseInfo(initOverrides) {
        const response = await this.getWarehouseInfoRaw(initOverrides);
        return await response.value();
    }
}
